import React from 'react';
import { Chip } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { getPlatformCategoryTone } from '../../themes/labels';
import type { PlatformChipProps } from './label.types';
import { getCategoryChipSx } from './label.styles';

const PlatformChip: React.FC<PlatformChipProps> = ({
  platform,
  size = 'small',
  selected = false,
  onClick
}) => {
  const tone = getPlatformCategoryTone(platform);

  return (
    <Chip
      label={platform}
      icon={selected ? <CheckIcon /> : undefined}
      size="small"
      clickable={Boolean(onClick)}
      onClick={onClick}
      sx={getCategoryChipSx(tone, size, selected)}
      aria-label={platform}
      aria-pressed={selected || undefined}
    />
  );
};

export default PlatformChip;
